import React, { useState } from 'react'

import useGeoFetch from './useGeoFetch'

import useUHCGeoFetch from './useUHCGeoFetch'

const GeoContext = React.createContext()

function useGeoProvider(
  startDate,
  endDate,
  showingDate,
  countiesStartDate,
  countiesEndDate,
  hrrWeekStartDate,
  hrrWeekEndDate,
  options,
  weekEndDate,
  indicator,
  location,
  fDate,
  tDate,
  regionName,
  locationCd,
  geoLocationType,
   vulGetCount,
  showAddsubscribe,
  showRiskResult,
  showProviders,
  regionSelectedDefault,  
  geoid,
  geotype,
  showPopup
 
) {  
  const [loadedDate] = useState(showingDate)
  const [UHCStateLoadedDate, setUHCStateLoadedDate] = useState(showingDate)
  const [UHCCountyLoadedDate, setUHCCountyLoadedDate] = useState(showingDate)
  const [getPinPopup, setPinPopup] = useState(showPopup)
  const [getGeoIdandGeoType, setGeoIdandGeoType] = useState({geoid:geoid,geo_type:geotype})
  const [dataStartDate, setDataStartDate] = useState(startDate)
  const [startDateCounties, setStartDateCounties] = useState(countiesStartDate)
   const [hrrDataWeekStartDate, setHrrDate] = useState(hrrWeekStartDate)
  const [hrrDataWeekEndDate, setHrrEndDate] = useState(hrrWeekEndDate)
  const [dataEndDate, setDataEndDate] = useState(endDate)
  const [dataEndDateCounties, setDataEndDateCounties] =
    useState(countiesEndDate)
  const [displayDate, setDisplayDate] = useState(showingDate)
  const [displayWeek, setDisplayWeek] = useState('')
  const [searchFilter, setSearchFilter] = useState('')
  const [showWeek, setShowWeek] = useState(0)
  const [timelineIsPaused, setTimelineIsPaused] = useState(true)
  const [countyDataLoaded, setCountyDataLoaded] = useState(false)
  const [mapOptions, setMapOptions] = useState(options)
  const [dataSelected, setDataSelected] = React.useState('revised_accuracy')
  const [regionSelected, setRegionSelected] = React.useState(regionSelectedDefault)
  const [isChecked, setIsChecked] = useState(false)
  const [lastweekEndDate, setLastWeekEndDate] = useState(weekEndDate)
  const [indicatorName, setIndicatorName] = useState(indicator)
  const [locationName, setLocationName] = useState(location)
  const [fromDate, setFromDate] = useState(fDate)
  const [toDate, setToDate] = useState(tDate)
  const [regionSelectedName, setRegionSelectedName] = useState(regionName)
  const [locationCode, setLocationCode] = useState(locationCd)
  const [locationType, setLocationType] = useState(geoLocationType)
  const [vulCount, setVulCount] = useState(vulGetCount)
  const [diseaseSelected, setDiseaseSelected] = useState(1)
  const [claimsFiled, setClaimsFiled] = useState()
  const [showProvidersMap, setShowProvidersMap] = useState(false)
  const [showAddsubscribePop, setShowAddsubscribePop] = useState(true)
  const [getRiskResult, setRiskResult] = useState()

  const [getRespiratoryState,setRespiratoryState]=useState('')
  const [getAcuityState,setAcuityState]=useState('')
  const [getComorbidityState,setComorbidityState]=useState('')
  const [getAllergyFilterState,setAllergyFilterState]=useState(1)
  const [exportButtonState,setExportButtonState]=useState(false)
  const [exportButtonEnable,setExportButtonEnable]=useState(false)

  
   const [getRefreshDateFilter,setRefreshDateFilter]=useState('All')
  const [getStateFilter,setStateFilter]=useState('All')
  const [getAgeGroupFilter,setAgeGroupFilter]=useState('All')
  const [getGenderFilter,setGenderFilter]=useState('All')
  const [getVaccineTypeFilter,setVaccineTypeFilter]=useState('All')

  return {
    loadedDate,
    UHCStateLoadedDate,
    UHCCountyLoadedDate,
    getPinPopup,
    dataStartDate,
    startDateCounties,
    dataEndDate,
    dataEndDateCounties,
    hrrDataWeekStartDate,
    hrrDataWeekEndDate,
    displayDate,
    displayWeek,
    searchFilter,
    showWeek,
    timelineIsPaused,
    countyDataLoaded,
    mapOptions,
    dataSelected,
    regionSelected,
    isChecked,
    lastweekEndDate,
    indicatorName,
    locationName,
    fromDate,
    toDate,
    regionSelectedName,
    locationCode,
    locationType,
     vulCount,
    claimsFiled,
    diseaseSelected,
    showAddsubscribePop,
    getRiskResult,
    showProvidersMap,
    getRespiratoryState,
    getAcuityState,
    getComorbidityState,
    getGeoIdandGeoType,
    getAllergyFilterState,
    exportButtonState,
    exportButtonEnable,
     getRefreshDateFilter,
    getStateFilter,
    getAgeGroupFilter,
    getGenderFilter,
    getVaccineTypeFilter,
    setLocationType,
    setLocationCode,
    setRegionSelectedName,
    setToDate,
    setFromDate,
    setLocationName,
    setIndicatorName,
    setLastWeekEndDate,
    setUHCStateLoadedDate,
    setUHCCountyLoadedDate,
    setPinPopup,
    
    setDataStartDate,
    setStartDateCounties,
    setDataEndDate,
    setDataEndDateCounties,
     setHrrDate,
    setHrrEndDate,
    setDisplayDate,
    setDisplayWeek,
    setSearchFilter,
    setShowWeek,
    setTimelineIsPaused,
    setCountyDataLoaded,
    setMapOptions,
    setDataSelected,
    setRegionSelected,
    setIsChecked,
     setVulCount,
    setDiseaseSelected,
    setShowAddsubscribePop,
    setRiskResult,
    setClaimsFiled,
    setShowProvidersMap,
    setRespiratoryState,
    setAcuityState,
    setComorbidityState,
    setGeoIdandGeoType,  
    setAllergyFilterState  ,
    setExportButtonState,
    setExportButtonEnable,
    setRefreshDateFilter,
    setStateFilter,
    setAgeGroupFilter,
    setGenderFilter,
    setVaccineTypeFilter
  }
}

const GeoProvider = ({
  children,
  startDate,
  startDateCounties,
  endDate,
  endDateCounties,
  displayDate,
  hrrDataWeekStartDate,
  hrrDataWeekEndDate,
  mapOptions,
  lastweekEndDate,
  indicatorName,
  locationName,
  fromDate,
  toDate,
  regionSelectedName,
  locationCode,
  locationType,
  vulCount,
  claimsFiled,
  diseaseSelected,
  showAddsubscribePop,
  getRiskResult,
  showProvidersMap,
  regionSelected,
  geoid,
  geotype,
  getRespiratoryState,
  getAcuityState,
  getComorbidityState,
  getAllergyFilterState,
  exportButtonState,
  exportButtonEnable
}) => {
  const dataFilter = useGeoProvider(
    startDate,
    endDate,
    displayDate,
    startDateCounties,
    endDateCounties,
     hrrDataWeekStartDate,
    hrrDataWeekEndDate,
    mapOptions,
    lastweekEndDate,
    indicatorName,
    locationName,
    fromDate,
    toDate,
    regionSelectedName,
    locationCode,
    locationType,
    vulCount,
    showAddsubscribePop,
    getRiskResult,
    showProvidersMap,
    regionSelected,
    geoid,geotype,
    getRespiratoryState,
    getAcuityState,
    getComorbidityState,
    getAllergyFilterState,
    exportButtonState,
    exportButtonEnable
  )

  return (
    <GeoContext.Provider value={dataFilter}>{children}</GeoContext.Provider>
  )
}

export const useGeoState = () => {
  const context = React.useContext(GeoContext)
  if (!context) {
    throw new Error('useGeoState must be used within an GeoProvider')
  }
  return context
}

export { GeoProvider as default, useGeoFetch, useUHCGeoFetch }